export default "__VITE_ASSET__BUQ0FaX6__"